module.exports = __webpack_public_path__ + "80f10bd.woff";